import { Button } from '../ui/button';
import { ChevronRight } from 'lucide-react';
import { trackButtonClick } from '../../utils/analytics';
import { resolveCtaClick } from '../../utils/ctaActions';
import { BRAND_GREEN, BRAND_GREEN_LIGHT, BRAND_GREEN_DARK } from './landingConstants';
import { ctaBackgroundStyle } from './ctaBackgroundStyle';

export function PrimaryCTASection({ content, goToSignup }) {
  const cta = content.primary_cta || {};
  const bgStyle = ctaBackgroundStyle(cta);
  return (
    <section key="primary_cta" id="primary_cta" data-section="primary_cta" className="py-20 px-4 sm:px-6 lg:px-8">
      <div
        className="max-w-4xl mx-auto rounded-3xl p-12 text-center relative overflow-hidden"
        style={{ background: `linear-gradient(135deg, ${BRAND_GREEN_DARK} 0%, ${BRAND_GREEN} 50%, ${BRAND_GREEN_LIGHT} 100%)` }}
      >
        {bgStyle && (
          <div
            aria-hidden="true"
            data-testid="primary-cta-bg-image"
            className="pointer-events-none absolute inset-0 rounded-3xl"
            style={bgStyle}
          />
        )}
        <div className="relative z-10">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">{cta.title}</h2>
          <p className="text-white/80 text-lg mb-8">{cta.subtitle}</p>
          <Button
            size="lg"
            className="bg-white text-[#007a33] hover:bg-gray-100 text-lg px-8 py-6 rounded-xl"
            onClick={() => { trackButtonClick('primary_cta_get_started', cta.buttonText); resolveCtaClick(cta, goToSignup); }}
          >
            {cta.buttonText}
            <ChevronRight className="w-5 h-5 ml-2" />
          </Button>
          <p className="text-white/80 text-sm mt-4">{cta.secondaryText}</p>
        </div>
      </div>
    </section>
  );
}
